// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Map from "../Data.Map/index.js";
import * as Data_Map_Extra from "../Data.Map.Extra/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Map_Serialized from "../Data.Map.Serialized/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_InternalParameterId from "../Restaumatic.Menu.V2.Types.InternalParameterId/index.js";
import * as Restaumatic_Menu_V2_Types_ParameterChoiceId from "../Restaumatic.Menu.V2.Types.ParameterChoiceId/index.js";
import * as Restaumatic_Menu_V2_Types_ParameterId from "../Restaumatic.Menu.V2.Types.ParameterId/index.js";
import * as Restaumatic_Menu_V2_Types_Parametric from "../Restaumatic.Menu.V2.Types.Parametric/index.js";
import * as Restaumatic_Menu_V2_Types_Parametric_Parametric from "../Restaumatic.Menu.V2.Types.Parametric.Parametric/index.js";
var MissingParameters = /* #__PURE__ */ (function () {
    function MissingParameters(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    MissingParameters.create = function (value0) {
        return function (value1) {
            return new MissingParameters(value0, value1);
        };
    };
    return MissingParameters;
})();
var MissingValue = /* #__PURE__ */ (function () {
    function MissingValue() {

    };
    MissingValue.value = new MissingValue();
    return MissingValue;
})();
var variantValue = Data_Map_Internal.singleton;
var variant = function (values) {
    return Data_Map_Internal.singleton(values)(true);
};
var valueParams = Data_Map.keys;
var singleValue = function (value) {
    return {
        values: Data_Newtype.wrap()(Data_Map_Internal.singleton(Data_Newtype.wrap()(Data_Map_Internal.empty))(value))
    };
};
var showParametricEvaluationError = {
    show: function (v) {
        if (v instanceof MissingParameters) {
            return "missing parameter ids: " + Data_Array.intercalate(Data_Monoid.monoidString)(", ")(Data_Functor.map(Data_Functor.functorArray)(Data_Show.show(Restaumatic_Menu_V2_Types_ParameterId.showParameterId))(Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray)(v.value0)));
        };
        if (v instanceof MissingValue) {
            return "missing value";
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Parametric (line 26, column 1 - line 28, column 38): " + [ v.constructor.name ]);
    }
};
var prop_parameterValuesNum = function (paramValues) {
    var expectedKeys = Data_Foldable.fold(Data_Foldable.foldableArray)(Data_Set.monoidSet(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId))(Data_Functor.map(Data_Functor.functorArray)(valueParams)(Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray)(paramValues)));
    return Data_Foldable.all(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(function (k) {
        return Data_Eq.eq(Data_Set.eqSet(Restaumatic_Menu_V2_Types_ParameterId.eqParameterId))(valueParams(k))(expectedKeys);
    })(Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray)(paramValues));
};
var parametricParams = /* #__PURE__ */ (function () {
    var $98 = Data_Set.unions(Data_Set.foldableSet)(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId);
    var $99 = Data_Set.map(Data_Set.ordSet(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId))((function () {
        var $103 = Data_Newtype.unwrap();
        return function ($104) {
            return Data_Map.keys($103($104));
        };
    })());
    var $100 = Data_Newtype.unwrap();
    var $101 = Data_Newtype.unwrap();
    return function ($102) {
        return $98($99(Data_Map.keys($100((function (v) {
            return v.values;
        })($101($102))))));
    };
})();
var prop_parametricNum = function (parametric) {
    var expectedKeys = parametricParams(parametric);
    var actualKeys = Data_Functor.map(Data_Functor.functorArray)((function () {
        var $105 = Data_Newtype.unwrap();
        return function ($106) {
            return valueParams($105($106));
        };
    })())(Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Map.keys(Data_Newtype.unwrap()((function (v) {
        return v.values;
    })(Data_Newtype.unwrap()(parametric))))));
    return Data_Foldable.all(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(Data_Eq.eq(Data_Set.eqSet(Restaumatic_Menu_V2_Types_ParameterId.eqParameterId))(expectedKeys))(actualKeys);
};
var parameters = function (v) {
    return Data_Set.unions(Data_Set.foldableSet)(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId)(Data_Set.map(Data_Set.ordSet(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId))((function () {
        var $107 = Data_Newtype.unwrap();
        return function ($108) {
            return Data_Map.keys($107($108));
        };
    })())(Data_Map.keys(Data_Newtype.unwrap()(v.values))));
};
var onlyInternalParameters = /* #__PURE__ */ (function () {
    var onlyInternal = function (v) {
        if (v instanceof Restaumatic_Menu_V2_Types_ParameterId.InternalParameter) {
            return new Data_Maybe.Just(v.value0);
        };
        if (v instanceof Restaumatic_Menu_V2_Types_ParameterId.CustomParameter) {
            return Data_Maybe.Nothing.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Parametric (line 165, column 3 - line 165, column 48): " + [ v.constructor.name ]);
    };
    return Data_Set.mapMaybe(Restaumatic_Menu_V2_Types_InternalParameterId.ordInternalParameterId)(onlyInternal);
})();
var onlyCustomParameters = /* #__PURE__ */ (function () {
    var onlyCustom = function (v) {
        if (v instanceof Restaumatic_Menu_V2_Types_ParameterId.CustomParameter) {
            return new Data_Maybe.Just(v.value0);
        };
        if (v instanceof Restaumatic_Menu_V2_Types_ParameterId.InternalParameter) {
            return Data_Maybe.Nothing.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Parametric (line 159, column 3 - line 159, column 44): " + [ v.constructor.name ]);
    };
    return Data_Set.mapMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(onlyCustom);
})();
var onlyCustomParameterValues = /* #__PURE__ */ (function () {
    var onlyCustom = function (v) {
        if (v.value0 instanceof Restaumatic_Menu_V2_Types_ParameterId.CustomParameter && v.value1 instanceof Restaumatic_Menu_V2_Types_ParameterChoiceId.CustomParameterChoice) {
            return new Data_Maybe.Just(new Data_Tuple.Tuple(v.value0.value0, v.value1.value0));
        };
        return Data_Maybe.Nothing.value;
    };
    var $109 = Data_Map_Internal.fromFoldable(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Data_Foldable.foldableArray);
    var $110 = Data_Array.mapMaybe(onlyCustom);
    var $111 = Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
    return function ($112) {
        return $109($110($111($112)));
    };
})();
var noValue = {
    values: /* #__PURE__ */ Data_Newtype.wrap()(Data_Map_Internal.empty)
};
var never = noValue;
var mapAssign = Data_Map_Internal.singleton;
var make = function (entries) {
    return {
        values: Data_Newtype.wrap()(Data_Map_Internal.fromFoldable(Data_Map_Serialized.ordMap(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId)(Restaumatic_Menu_V2_Types_ParameterChoiceId.ordParameterChoiceId))(Data_Foldable.foldableArray)(Data_Functor.map(Data_Functor.functorArray)(Data_Bifunctor.lmap(Data_Bifunctor.bifunctorTuple)(Data_Newtype.wrap()))(entries)))
    };
};
var isPossible = function (dict) {
    return dict.isPossible;
};
var internalAssign = function (param) {
    return function (value) {
        return Data_Map_Internal.singleton(new Restaumatic_Menu_V2_Types_ParameterId.InternalParameter(param))(new Restaumatic_Menu_V2_Types_ParameterChoiceId.InternalParameterChoice(value));
    };
};
var fromInternalParameterValues = /* #__PURE__ */ (function () {
    var toArray = Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
    var $113 = Data_Map_Internal.fromFoldable(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId)(Data_Foldable.foldableArray);
    var $114 = Data_Functor.map(Data_Functor.functorArray)(function (v) {
        return new Data_Tuple.Tuple(new Restaumatic_Menu_V2_Types_ParameterId.InternalParameter(v.value0), new Restaumatic_Menu_V2_Types_ParameterChoiceId.InternalParameterChoice(v.value1));
    });
    return function ($115) {
        return $113($114(toArray($115)));
    };
})();
var fromCustomParameterValues = /* #__PURE__ */ (function () {
    var toArray = Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
    var $116 = Data_Map_Internal.fromFoldable(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId)(Data_Foldable.foldableArray);
    var $117 = Data_Functor.map(Data_Functor.functorArray)(function (v) {
        return new Data_Tuple.Tuple(new Restaumatic_Menu_V2_Types_ParameterId.CustomParameter(v.value0), new Restaumatic_Menu_V2_Types_ParameterChoiceId.CustomParameterChoice(v.value1));
    });
    return function ($118) {
        return $116($117(toArray($118)));
    };
})();
var eqParametricEvaluationError = function (dictEq) {
    return {
        eq: function (x) {
            return function (y) {
                if (x instanceof MissingParameters && y instanceof MissingParameters) {
                    return Data_Eq.eq(Data_Set.eqSet(Restaumatic_Menu_V2_Types_ParameterId.eqParameterId))(x.value0)(y.value0) && Data_Eq.eq(Restaumatic_Menu_V2_Types_Parametric_Parametric.eqParametric(dictEq))(x.value1)(y.value1);
                };
                if (x instanceof MissingValue && y instanceof MissingValue) {
                    return true;
                };
                return false;
            };
        }
    };
};
var customAssign = function (param) {
    return function (value) {
        return Data_Map_Internal.singleton(new Restaumatic_Menu_V2_Types_ParameterId.CustomParameter(param))(new Restaumatic_Menu_V2_Types_ParameterChoiceId.CustomParameterChoice(value));
    };
};
var asInternalParameterChoiceId = function (v) {
    if (v instanceof Restaumatic_Menu_V2_Types_ParameterChoiceId.InternalParameterChoice) {
        return new Data_Maybe.Just(v.value0);
    };
    return Data_Maybe.Nothing.value;
};
var asCustomParameterChoiceId = function (v) {
    if (v instanceof Restaumatic_Menu_V2_Types_ParameterChoiceId.CustomParameterChoice) {
        return new Data_Maybe.Just(v.value0);
    };
    return Data_Maybe.Nothing.value;
};
var applyParameters = function (v) {
    return function (providedParamValues) {
        var providedParams = Data_Map.keys(providedParamValues);
        var remainingParams = Data_Set.difference(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId)(parametricParams(v))(providedParams);
        var checkVariant = function (v1) {
            var partitionParams = function (paramId) {
                return function (_paramValue) {
                    return Data_Set.member(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId)(paramId)(providedParams);
                };
            };
            var usedVariantParams = Data_Map_Extra.partitionWithKey(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId)(partitionParams)(Data_Newtype.unwrap()(v1.value0));
            var $68 = Data_Map_Internal.isSubmap(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId)(Restaumatic_Menu_V2_Types_ParameterChoiceId.eqParameterChoiceId)(usedVariantParams.yes)(providedParamValues);
            if ($68) {
                return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(new Data_Tuple.Tuple(Data_Newtype.wrap()(usedVariantParams.no), v1.value1));
            };
            return Data_Maybe.Nothing.value;
        };
        var filtered = {
            values: Data_Newtype.wrap()(Data_Map_Internal.fromFoldable(Data_Map_Serialized.ordMap(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId)(Restaumatic_Menu_V2_Types_ParameterChoiceId.ordParameterChoiceId))(Data_Foldable.foldableArray)(Data_Array.mapMaybe(checkVariant)(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Newtype.unwrap()((function (v1) {
                return v1.values;
            })(v))))))
        };
        return {
            missingParameters: remainingParams,
            remainingOptions: filtered
        };
    };
};
var evaluateAllValues = function (dictOrd) {
    return function (parametric) {
        return function (valuesToApply) {
            return Data_Set.fromFoldable(Data_Foldable.foldableArray)(dictOrd)(Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.snd)(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Newtype.unwrap()((function (v) {
                return v.values;
            })(Data_Newtype.unwrap()((applyParameters(parametric)(valuesToApply)).remainingOptions))))));
        };
    };
};
var evaluateParametric = function (parametric) {
    return function (valuesToApply) {
        var v = applyParameters(parametric)(valuesToApply);
        var v1 = Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Newtype.unwrap()(v.remainingOptions.values));
        if (v1.length === 0 && Data_Set.isEmpty(v.missingParameters)) {
            return new Data_Either.Left(MissingValue.value);
        };
        if (v1.length === 1 && Data_Set.isEmpty(v.missingParameters)) {
            return new Data_Either.Right(v1[0].value1);
        };
        return new Data_Either.Left(new MissingParameters(v.missingParameters, v.remainingOptions));
    };
};
var isMemberOfParametricSet = function (parametric) {
    return function (valuesToApply) {
        return Data_Eq.eq(Data_Either.eqEither(eqParametricEvaluationError(Data_Eq.eqBoolean))(Data_Eq.eqBoolean))(evaluateParametric(parametric)(valuesToApply))(new Data_Either.Right(true));
    };
};
var isParametricPossible = {
    isPossible: function (parametric) {
        return function (values$prime) {
            var v = evaluateParametric(parametric)(values$prime);
            if (v instanceof Data_Either.Right) {
                return true;
            };
            if (v instanceof Data_Either.Left && v.value0 instanceof MissingValue) {
                return false;
            };
            if (v instanceof Data_Either.Left && (v.value0 instanceof MissingParameters && Data_Map_Internal.isEmpty(Data_Newtype.unwrap()(v.value0.value1.values)))) {
                return false;
            };
            if (v instanceof Data_Either.Left && v.value0 instanceof MissingParameters) {
                return true;
            };
            throw new Error("Failed pattern match at Restaumatic.Menu.V2.Parametric (line 146, column 5 - line 150, column 52): " + [ v.constructor.name ]);
        };
    }
};
var isParametricPossibleBoole = {
    isPossible: function (parametric) {
        return function (values$prime) {
            var v = evaluateParametric(parametric)(values$prime);
            if (v instanceof Data_Either.Right) {
                return v.value0;
            };
            if (v instanceof Data_Either.Left && v.value0 instanceof MissingValue) {
                return false;
            };
            if (v instanceof Data_Either.Left && v.value0 instanceof MissingParameters) {
                return !Data_Map_Internal.isEmpty(Data_Map_Internal.filter(Data_Map_Serialized.ordMap(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId)(Restaumatic_Menu_V2_Types_ParameterChoiceId.ordParameterChoiceId))(Control_Category.identity(Control_Category.categoryFn))(Data_Newtype.unwrap()(v.value0.value1.values)));
            };
            throw new Error("Failed pattern match at Restaumatic.Menu.V2.Parametric (line 140, column 5 - line 143, column 116): " + [ v.constructor.name ]);
        };
    }
};
var any = function (pred) {
    return function (v) {
        return Data_Foldable.any(Data_Map_Internal.foldableMap)(Data_HeytingAlgebra.heytingAlgebraBoolean)(pred)(Data_Newtype.unwrap()(v.values));
    };
};
var always = /* #__PURE__ */ singleValue(true);
export {
    MissingParameters,
    MissingValue,
    always,
    any,
    applyParameters,
    asCustomParameterChoiceId,
    asInternalParameterChoiceId,
    customAssign,
    evaluateAllValues,
    evaluateParametric,
    fromCustomParameterValues,
    fromInternalParameterValues,
    internalAssign,
    isMemberOfParametricSet,
    isPossible,
    make,
    mapAssign,
    never,
    noValue,
    onlyCustomParameterValues,
    onlyCustomParameters,
    onlyInternalParameters,
    parameters,
    parametricParams,
    prop_parameterValuesNum,
    prop_parametricNum,
    singleValue,
    valueParams,
    variant,
    variantValue,
    eqParametricEvaluationError,
    showParametricEvaluationError,
    isParametricPossibleBoole,
    isParametricPossible
};
export {
    CustomParameterChoice,
    InternalParameterChoice,
    CustomParameter,
    InternalParameter
} from "../Restaumatic.Menu.V2.Types.Parametric/index.js";
export {
    Parametric
} from "../Restaumatic.Menu.V2.Types.Parametric.Parametric/index.js";
//# sourceMappingURL=index.js.map
